import React from "react";
import { withStyles } from "@material-ui/core/styles";

import {
  Datagrid,
  DateField,
  List,
  ShowButton,
  TextField,
  NumberField,
  TextInput,
  EditButton,
} from "react-admin";

import { MyListActions } from "../__common/MyListActions";
import { MyListPagination } from "../__common/MyListPagination";

const styles = (theme) => ({
  title: {
    maxWidth: "20em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

const filters = [
  <TextInput label="Search" source="code" alwaysOn />,
  <TextInput label="Culture medium" source="culture_medium" />,
];

export const CultureMediaList = withStyles(styles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={filters}
    actions={<MyListActions />}
    sort={{ field: "code", order: "ASC" }}
    pagination={<MyListPagination />}
    perPage={25}
  >
    <Datagrid>
      <TextField source="code" />
      <TextField source="culture_medium" />
      <DateField
        source="createdAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <DateField
        source="updatedAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <EditButton />
      <ShowButton />
    </Datagrid>
  </List>
));
